var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMAvanceNomina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_avance_nomina"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avance_de_N\\xF3mina",
    "data-name": "Avance de N\\xF3mina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.64,47.14,34.52,58.38a.4.4,0,0,1-.64,0L23.6,44.62l-5.93,6.06,15,15a.39.39,0,0,0,.56,0L48.05,51H45.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.59,48.46a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4H17.41l.26-.28-2.22-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.41,51a.4.4,0,0,0,.4-.4v-1.7a.4.4,0,0,0-.4-.4H50.55L48.05,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.06,43.22a.4.4,0,0,0-.66,0L34.17,54.6l-10-13.44a.4.4,0,0,0-.61,0l-7.17,7.34h-.9l2.22,2.22,5.93-6.06L33.88,58.39a.4.4,0,0,0,.64,0l8.12-11.24L45.14,51h2.91l2.5-2.5H46.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72,33.28.28a.39.39,0,0,0-.56,0L.28,32.72a.39.39,0,0,0,0,.56L15.45,48.46h.9l7.17-7.34a.4.4,0,0,1,.61,0l10,13.44L42.4,43.2a.4.4,0,0,1,.66,0l3.43,5.24h4.06L65.72,33.28A.39.39,0,0,0,65.72,32.72ZM37.5,41.22v3.54a.4.4,0,0,1-.4.4H29.78a.4.4,0,0,1-.4-.4V41.48a15.59,15.59,0,0,1-6.81-2.75l-1.29-1a.39.39,0,0,1-.12-.48l.67-1.5,1.72-3.81,1.1-2.44a7.53,7.53,0,0,1-2.6-6c0-4.26,2.81-7.54,7.33-8.77v-3.5a.4.4,0,0,1,.4-.4H37.1a.4.4,0,0,1,.4.4v3.32a15.35,15.35,0,0,1,5.17,2l1.48.94a.4.4,0,0,1,.15.49l-.65,1.63-1.56,3.83-1,2.37a7.5,7.5,0,0,1,3.65,6.73C44.77,36.72,42,40,37.5,41.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,26.16v-5.3a12.87,12.87,0,0,1,4.77,1.62l1.56-3.84A14.17,14.17,0,0,0,35,16.74v-3.4H31.88V16.8c-4.93.57-7.33,3.4-7.33,6.71,0,4.46,3.87,5.61,7.33,6.46v5.2A12.54,12.54,0,0,1,25.83,33l-1.72,3.8a14.75,14.75,0,0,0,7.77,2.5v3.4H35V39.17c4.89-.6,7.27-3.4,7.27-6.65C42.27,28.13,38.46,27,35,26.16Zm-3.12-.78c-1.37-.44-2.31-1-2.31-2.12s.66-1.93,2.31-2.31ZM35,35.05V30.74c1.34.47,2.24,1.07,2.24,2.16S36.56,34.71,35,35.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35,30.74v4.31c1.56-.34,2.24-1.16,2.24-2.15S36.34,31.21,35,30.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.57,23.26c0,1.09.94,1.68,2.31,2.12V21C30.23,21.33,29.57,22.23,29.57,23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.12,25.79l1-2.37,1.56-3.83L44.3,18a.4.4,0,0,0-.15-.49l-1.48-.94a15.35,15.35,0,0,0-5.17-2V11.24a.4.4,0,0,0-.4-.4H29.78a.4.4,0,0,0-.4.4v3.5c-4.52,1.23-7.33,4.51-7.33,8.77a7.53,7.53,0,0,0,2.6,6l-1.1,2.44-1.72,3.81-.67,1.5a.39.39,0,0,0,.12.48l1.29,1a15.59,15.59,0,0,0,6.81,2.75v3.28a.4.4,0,0,0,.4.4H37.1a.4.4,0,0,0,.4-.4V41.22c4.48-1.25,7.27-4.5,7.27-8.7A7.5,7.5,0,0,0,41.12,25.79ZM35,39.17v3.49H31.88v-3.4a14.75,14.75,0,0,1-7.77-2.5L25.83,33a12.54,12.54,0,0,0,6.05,2.21V30c-3.46-.85-7.33-2-7.33-6.46,0-3.31,2.4-6.14,7.33-6.71V13.34H35v3.4a14.17,14.17,0,0,1,6.33,1.9l-1.56,3.84A12.87,12.87,0,0,0,35,20.86v5.3c3.46.81,7.27,2,7.27,6.36C42.27,35.77,39.89,38.57,35,39.17Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAvanceNomina);
export default __webpack_public_path__ + "static/media/m_avance_nomina.c0258ab086e2f1f26779e08d5d0e6248.svg";
export { ForwardRef as ReactComponent };